// Pakketten (build 2.4). Er is nog geen licentiemodel: het gekozen pakket wordt bij
// een aanmelding opgeslagen zodat de creator weet wat hij moet factureren. Dezelfde
// sleutels staan in functions/index.js (PACKAGE_KEYS) — bij een wijziging beide aanpassen.

export const GROUPS = [
  { key: "jeugd", label: "Jeugd", sub: "Rood, oranje, groen en geel", bars: ["#B83232", "#B85A12", "#2F7D47", "#E8C12E"] },
  { key: "volwassenen", label: "Volwassenen", sub: "Alle volwassenengroepen", bars: ["#6A4BB0"] },
  { key: "compleet", label: "Compleet", sub: "Jeugd en volwassenen", bars: ["#B83232", "#B85A12", "#2F7D47", "#E8C12E", "#6A4BB0"] },
];

export const TIERS = [
  { key: "basic", label: "Basic", items: ["Seizoensplannen per niveau", "Seizoens- en weekoverzicht", "Oefeningen met uitleg"] },
  { key: "plus", label: "Plus", items: ["Alles uit Basic"], extras: ["Oefeningtekeningen", "Tweede les per week"] },
];

// Prijzen per pakket; null = nog niet bekend ("Prijs volgt").
export const PRICES = {
  "jeugd-basic": null, "volwassenen-basic": null, "compleet-basic": null,
  "jeugd-plus": null, "volwassenen-plus": null, "compleet-plus": null,
};

export const PACKAGES = [];
TIERS.forEach(function (t) {
  GROUPS.forEach(function (g) {
    PACKAGES.push({ key: g.key + "-" + t.key, label: g.label + " " + t.label, group: g, tier: t });
  });
});

export function packageLabel(key) {
  var p = PACKAGES.find(function (x) { return x.key === key; });
  return p ? p.label : "";
}

export function priceLabel(key) {
  var v = PRICES[key];
  return v == null ? "Prijs volgt" : "€ " + v;
}
